import classNames from "classnames";
import React, { type TextareaHTMLAttributes, useEffect, useRef } from "react";

interface ITextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  as?: "default";
  isError?: boolean;
  className?: string;
}

export default function TextArea({ id, isError = false, placeholder, className, ...props }: ITextAreaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  const handleResizeHeight = () => {
    if (!ref.current) return;
    ref.current.style.height = "auto"; //height 초기화
    ref.current.style.height = `${ref.current.scrollHeight + 6}px`;
  };

  useEffect(() => {
    handleResizeHeight();
  }, []);

  return (
    <textarea
      className={classNames(
        [
          "placeholder:text-dark-grey min-h-48 resize-none rounded border border-solid border-black p-2.5 outline-hidden",
          isError && "border-red",
        ],
        className,
      )}
      id={id}
      onInput={handleResizeHeight}
      placeholder={placeholder}
      ref={ref}
      {...props}
    />
  );
}
